import React from 'react';
import { Container, Titulo, LinkA, Img, DivLogin, DivSistema, Link } from './styles';
import imgGoverno from '../../assets/logo-governo-horizontal-branca.svg'
import { Icon } from '@material-ui/core';


function Header({ logado, usuario, logout }) {
  return (
    <Container>
      <DivSistema>
        <LinkA href="http://www.ms.gov.br" target="_blank" rel="noopener noreferrer">
          <Img src={imgGoverno} alt="Governo MS" />
        </LinkA>
        <LinkA href="/" >
          <Titulo>
            {logado ? 'ACERVO PRIVADO' : 'PARECERES'} | <b>PGE MS</b>
          </Titulo>
        </LinkA>
      </DivSistema>
      <DivLogin>
        {logado &&
          <Link onClick={() => logout()} logado={logado}>
            {usuario.nomeUsuario}
            <Icon>
              exit_to_app
            </Icon>
          </Link>
        }
        {!logado &&
          <Link to="/login" logado={logado}>
            ACESSO RESTRITO
          </Link>
        }
      </DivLogin>
    </Container>
  );
}

export default Header;